// 机经题库列表父类列表

import type { settingData } from '@/api/common.api'
import { http } from '@/utils'
import { ElMessage } from 'element-plus'
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

interface defaultUserInfo extends Partial<UserInfo> {
  icon: string
  newMemberLevel: 0 | 1 | 2
  nonMemberDomains: NonMemberDomain[]
}

export const useUserStore = defineStore(
  'user',
  () => {
    const userInfo = ref<defaultUserInfo>({
      icon: new URL('@/baidupteAssets/icon/default_190920.png', import.meta.url).href,
      newMemberLevel: 0,
      nonMemberDomains: []
    })

    const getUserInfo = () => {
      return http
        .get<defaultUserInfo>('/api/auth/getUser')
        .then((res) => {
          userInfo.value = res.data
          return res.data
        })
        .catch(() => {
          // 获取用户信息失败清空token
          // localStorage.clear();
          // location.reload();
        })
    }
    /**
     * 是否为会员
     */
    const isMembers = computed(() => {
      if (userInfo.value && userInfo.value.newMemberLevel > 0) {
        return true
      }
      return false
    })

    /**
     * 是否有评测次数
     * @returns boolean
     */
    const isEnergy = () => {
      // 判断是否为会员
      if (isMembers.value) {
        return true
      }
      // 非会员判断是否有评测次数
      if (
        !userInfo.value ||
        !userInfo.value.nonMemberDomains ||
        userInfo.value.nonMemberDomains[0].energy <= 0
      ) {
        // 判断是否为网校用户
        if (JSON.parse(window.localStorage.getItem('isZoom') || 'false')) {
          ElMessage.warning({
            message: '请联系相关老师开通VIP',
            duration: 3000
          })
          return false
        }
        // 没有用户信息
        ElMessage.warning({
          message: '剩余次数不够',
          duration: 3000
        })
        return false
      }
      return true
    }
    return {
      userInfo,
      getUserInfo,
      isMembers,
      isEnergy
    }
  },
  {
    persist: {
      storage: localStorage,
      paths: ['userInfo']
    }
  }
)
export interface UserInfo {
  id: number
  uid: string
  icon: string
  nickName: string
  sex: number
  status: number
  language: string
  createTime: number
  tuoAge: number
  isMembers: number
  isOldMembers: number
  isTrialFree: number
  energy: number
  clockDay: number
  canClock: number
  vipBuyUrl: string
  isCollectInformation: boolean
  isCourseMember: number
  isCourseRefuel: number
  replacePhone: string
  userLevel: number
  nonMemberDomains?: NonMemberDomain[]
  newMemberLevel: number
  specialCode: number
  isedu: number
  showFreeMemberPopupsFlag: number
  hcadets: boolean
  courseDate: number
  newMemberEndTime: number
  bornDate?: string
  mobileToken: {
    expireIn: number
    token: string
  }
  userQuestionSetting: settingData
}

interface NonMemberDomain {
  type: number
  energy: number
  uid: string
}
